import DashboardLayout from "@/views/LayoutView/DashboardLayout.vue";

import AdminArchive from "@/views/AdminView/AdminArchive.vue";
import ConferenceArchive from "@/views/AdminView/ConferenceArchive.vue";
import JournalArchive from "@/views/AdminView/JournalArchive.vue";
import MemberArchive from "@/views/AdminView/MemberArchive.vue";
import ConferenceGallery from "@/views/AdminView/ConferenceGallery.vue";

const adminMenu = {
  path: "/admin",
  component: DashboardLayout,
  name: "Admin",
  children: [
    {
      path: "archives",
      name: "archives",
      component: AdminArchive,
      meta: {
        requiresAuth: true,
        requiredRoles: ["content", "master", "member", "account", "editor"],
        title: "topnav.admin_archive",
      },
    },
    {
      path: "conference/archives",
      name: "conference archives",
      component: ConferenceArchive,
      meta: {
        requiresAuth: true,
        requiredRoles: ["content", "master", "member", "account", "editor"],
        title: "topnav.conference_archive",
      },
    },
    {
      path: "conference/gallery",
      name: "conference gallery",
      component: ConferenceGallery,
      meta: {
        requiresAuth: true,
        requiredRoles: ["content", "master", "member", "account", "editor"],
        title: "topnav.conference_gallery",
      },
    },
    {
      path: "journal/archives",
      name: "journal archives",
      component: JournalArchive,
      meta: {
        requiresAuth: true,
        requiredRoles: ["content", "master", "member", "account", "editor"],
        title: "topnav.journal_archive",
      },
    },
    {
      path: "member/archives",
      name: "member archives",
      component: MemberArchive,
      meta: {
        requiresAuth: true,
        requiredRoles: ["content", "master", "member", "account", "editor"],
        title: "topnav.member_archive",
      },
    },
  ],
};

export default adminMenu;
